import { Account, EmailRequest, RedirectToken, Template, Payment, ServerConfig } from "./Types";
import { QuoteDeduction } from "./Quote/QuoteDeduction";
import { QuoteLineItem } from "./Quote/QuoteLineItem";
import { QuoteCreateLineItem } from "./Quote/QuoteCreateLineItem";
import { Quote } from "./Quote/Quote";
import { getItem, getItems, update, remove, get, create, upload, post } from "./Api";
import { AdditionalItemsClassification, AdditionalItemsCode } from "../app/consts";
import { getConfig } from "../app/config";
import { quoteVatRate } from "../app/utils";

export async function addExtraItemToQuote(quote: Quote, description: string, price: number) {
  return create<QuoteCreateLineItem, QuoteLineItem>(`Store/Quote/${quote.id}/Product`, {
    // TODO : hardcoded code
    // Should interface directly to pricing api to allow user search for specific product to add
    productCode: AdditionalItemsCode,
    name: "Additional Items",
    description: description,
    price: price,
    vatRate: quoteVatRate(quote),
    classification: AdditionalItemsClassification,
    quantity: 1
  });
}

export async function updateQuoteItem(quoteId: string, productId: string, quoteLineItem: QuoteLineItem) {
  var path = `Store/Quote/${quoteId}/Product/${productId}`;
  return update<QuoteLineItem>(path, quoteLineItem);
}

export async function deleteQuoteItem(quoteId: string, productId: string) {
  var path = `Store/Quote/${quoteId}/Product/${productId}`;
  return remove(path);
}

export async function updateQuoteDeduction(quoteId: string, deductionId: string, quoteDeduction: QuoteDeduction) {
  var path = `Store/Quote/${quoteId}/Deduction/${deductionId}`;
  return update<QuoteDeduction>(path, quoteDeduction);
}

export async function deleteQuoteDeduction(quoteId: string, deductionId: string) {
  var path = `Store/Quote/${quoteId}/Deduction/${deductionId}`;
  return remove(path);
}

/**  Accounts  **/
export async function getAccount(id: string) {
  var account = await getItem<Account>("Store/Contact", id);
  return account;
}

/** Emails  **/
export async function mailQuoteToUser(
  quoteId: string,
  emailAddress: string,
  name: string,
  comments: string,
  templateId: string,
  file: File | null
) {
  var body: EmailRequest = {
    emailAddress,
    name,
    comments,
    templateId,
    file,
    sendQuotePdf: false
  };

  var path = `Store/Email/Quote/${quoteId}`;

  const formData = new FormData();

  for (let key in body) {
    formData.append(key, body[key]);
  }

  return upload<EmailRequest>(path, formData);
}

export async function mailPaymentLink(
  quoteId: string,
  emailAddress: string,
  name: string,
  templateId: string,
  amount: number
) {
  var body: EmailRequest = {
    emailAddress,
    name,
    templateId,
    amount
  };

  var path = `Store/Email/Quote/${quoteId}/PaymentLink`;

  return post<EmailRequest>(path, body);
}

export async function getTemplates(): Promise<Template[]> {
  return getItems<Template>(`Store/Email/Templates`);
}

/** Redirect **/
export async function getRedirect(token: string) {
  var path = `Store/Redirect/Token/${token}`;
  return get<RedirectToken>(path);
}

/** Payments **/
export async function createPaymentSession(quoteId: string) {
  var path = `Store/payment/session`;
  var request = {
    quoteId: quoteId,
    successUrl: `${getConfig().Hostname}/quote/${quoteId}?payment`,
    cancelUrl: `${getConfig().Hostname}/quote/cart/${quoteId}`
  } as PaymentRequest;
  return create<PaymentRequest, PaymentResponse>(path, request);
}

export async function createCustomerPortalRedirect(quoteId: string) {
  var path = `store/payment/portal`;
  var request = {
    quoteId: quoteId,
    successUrl: `${getConfig().Hostname}/quote/${quoteId}?payment`
  } as PaymentRequest;
  return create<PaymentRequest, string>(path, request);
}

export async function paymentStatus(paymentId: string) {
  var path = `Store/payment/${paymentId}`;
  return get<Payment>(path);
}

export async function refreshPayments(quoteId: string) {
  var path = `Store/payment/quote/${quoteId}/refresh`;
  return get<Payment[]>(path);
}

export async function GetPublicConfig() {
  return get<ServerConfig>(`config`);
}

export async function GetClientConfig() {
  return get<ServerConfig>(`admin/client/config`);
}

interface PaymentResponse {
  paymentId: string;
  stripeSessionId: string;
}

interface PaymentRequest {
  quoteId: string;
  successUrl: string;
  cancelUrl: string;
}
